export const ONLINE_ONLY_EVENT_TYPES = new Set([
  "status_change",
  "closure_released",
  "closure_deceased",
  "plan_change",
  "care_site_change",
]);

export const OFFLINE_ALLOWED_EVENT_TYPES = new Set([
  "weight",
  "free_text",
  "diagnosis_change",
  "place_change",
  "intake_snapshot",
  "image_ref",
  "medication_dose",
  "treatment",
  "examination",
  "care_hint_change",
]);

export function assertEventsAllowedOffline(
  events: Array<{ event_type: string }>,
  isOnline: boolean
): void {
  if (isOnline) return;
  for (const event of events) {
    if (ONLINE_ONLY_EVENT_TYPES.has(event.event_type)) {
      throw new Error("Diese Aktion ist nur online möglich.");
    }
  }
}
